import { Notifications, UserForm } from '@prometheus/features';
import {
  getNotifications,
  signOutUser,
  updateNotifications,
  getNotificationsUnread,
} from '@prometheus/redux';
import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';
import { Breadcrumbs } from '../Breadcrumbs/Breadcrumbs';
import SideNavigation from '../SideNavigation';
import {
  ContentContainer,
  LayoutContainer,
  NavigationSubContainer,
  PageContainer,
  UserActionsContainer,
} from './AppLayout.styles';
import { UserDTO, BaseState } from '@prometheus/types';

export const AppLayout: FC<{ modulesSideNavigation: any }> = ({
  modulesSideNavigation,
}) => {
  const currentUser = useSelector<BaseState, UserDTO>(state => state.user.data);

  return (
    <LayoutContainer>
      <SideNavigation list={modulesSideNavigation} />

      <ContentContainer>
        <NavigationSubContainer>
          {currentUser?.email && (
            <>
              <Breadcrumbs />
              <UserActionsContainer>
                <Notifications
                  getNotifications={getNotifications}
                  updateNotifications={updateNotifications}
                  getNotificationsUnread={getNotificationsUnread}
                />
                <UserForm onLogout={signOutUser} />
              </UserActionsContainer>
            </>
          )}
        </NavigationSubContainer>

        <PageContainer>
          <Outlet />
        </PageContainer>
      </ContentContainer>
    </LayoutContainer>
  );
};
